import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { Grid, Row, Col } from 'react-bootstrap';
import './MobileGamePage.css';
import Game from '../../components/Game';
import MobileGameHeader from '../../components/MobileGameHeader';
import ErrorNotificationPage from 'components/ErrorNotificationPage';

class MobileGamePage extends Component {
  constructor(props) {
    super(props);

    this.onGameStartError = this.onGameStartError.bind(this);

    this.state = {
      error: undefined
    };
  }

  onGameStartError(message) {
    this.setState({
      error: message
    });
  }

  render() {
    const { match } = this.props;
    const gameName = match.params.game;

    return (
      <ErrorNotificationPage
        notificationMessage={this.state.error}
        redirectUrl="/mobile/games"
      >
        <Helmet>
          <title>Game</title>
        </Helmet>
        <MobileGameHeader />
        <Grid className="main-container game-container mobile">
          <Row className="game-wrapper">
            <Col xs={12}>
              <Game onError={this.onGameStartError} gameName={gameName} />
            </Col>
          </Row>
        </Grid>
      </ErrorNotificationPage>
    );
  }
}

export default MobileGamePage;



// WEBPACK FOOTER //
// ./src/containers/MobileGamePage/index.js